<nav
  class="hr-sidebar"
  [class.collapsed]="!isExpanded()"
  aria-label="Primary"
  (scroll)="onNavScroll()"
>
  <ul class="menu list-unstyled mb-0">
    @for (item of menu(); track item.label) {
      @if (item.kind === 'leaf') {
        <li (mouseenter)="onLeafEnter($event, item.label, item.label)" (mouseleave)="onRowLeave()">
          <a
            class="menu-row"
            [routerLink]="item.route"
            routerLinkActive="active"
            ariaCurrentWhenActive="page"
            [attr.aria-label]="item.label"
          >
            <lucide-icon [img]="item.icon" [size]="iconSize()" class="menu-icon"></lucide-icon>
            @if (isExpanded()) {
              <span class="menu-label">{{ item.label }}</span>
            }
          </a>
        </li>
      } @else {
        <li (mouseenter)="onGroupEnter($event, item)" (mouseleave)="onRowLeave()">
          <button
            type="button"
            class="menu-row"
            [class.active]="isGroupActive(item.id)"
            [attr.aria-label]="item.label"
            [attr.aria-expanded]="isExpanded() ? isMenuOpen(item.id) : popover()?.id === item.id"
            [attr.aria-controls]="isExpanded() && isMenuOpen(item.id) ? item.id : null"
            (click)="toggleMenu(item.id, $event)"
            (keydown)="onGroupKeydown($event, item)"
          >
            <lucide-icon [img]="item.icon" [size]="iconSize()" class="menu-icon"></lucide-icon>
            @if (isExpanded()) {
              <span class="menu-label">{{ item.label }}</span>
              <lucide-icon
                [img]="isMenuOpen(item.id) ? chevronUp : chevronDown"
                [size]="14"
                class="caret"
              ></lucide-icon>
            }
          </button>
          @if (isExpanded() && isMenuOpen(item.id)) {
            <ul [id]="item.id" class="menu-items list-unstyled" @slideExpand>
              @for (child of item.children; track child.label) {
                <li>
                  <a
                    [routerLink]="child.route"
                    routerLinkActive="active"
                    ariaCurrentWhenActive="page"
                    class="submenu-link"
                    >{{ child.label }}</a
                  >
                </li>
              }
            </ul>
          }
        </li>
      }
    }
  </ul>

  <div
    class="sidebar-footer"
    (mouseenter)="
      onLeafEnter($event, 'toggle', isExpanded() ? 'Collapse sidebar' : 'Expand sidebar')
    "
    (mouseleave)="onRowLeave()"
  >
    <button
      type="button"
      class="menu-row toggle-btn"
      [attr.aria-label]="isExpanded() ? 'Collapse sidebar' : 'Expand sidebar'"
      (click)="onToggleSidebar()"
    >
      <lucide-icon
        [img]="isExpanded() ? collapseIcon : expandIcon"
        [size]="iconSize()"
        class="menu-icon"
      ></lucide-icon>
      @if (isExpanded()) {
        <span class="menu-label">Collapse</span>
      }
    </button>
  </div>
</nav>

@if (popover(); as p) {
  <div
    class="hr-sidebar-flyout"
    [class.flyout-leaf]="p.children.length === 0"
    tabindex="-1"
    [attr.aria-label]="p.label"
    [style.top.px]="p.top"
    (mouseenter)="onPopoverEnter()"
    (mouseleave)="onPopoverLeave()"
    (keydown)="onPopoverKeydown($event)"
    @popoverFade
  >
    @if (p.children.length > 0) {
      <div class="flyout-header">{{ p.label }}</div>
      <ul class="flyout-items list-unstyled">
        @for (child of p.children; track child.label) {
          <li>
            <a
              #flyoutLink
              [routerLink]="child.route"
              routerLinkActive="active"
              ariaCurrentWhenActive="page"
              class="flyout-link"
              (click)="onPopoverItemClick()"
              >{{ child.label }}</a
            >
          </li>
        }
      </ul>
    } @else {
      <div class="flyout-label">{{ p.label }}</div>
    }
  </div>
}
